import { NotificationTypes } from "Enums";
import { ServiceProvider } from "Service";
import { Navigation } from "Core";
import { Page } from "./Page";
import CancellationToken from "cancellationtoken";

export class RefreshCachePage extends Page {
    private view: kendo.View;

    constructor(serviceProvider: ServiceProvider) {
        super(serviceProvider);
    }

    async render(layout: kendo.Layout, cancellationToken: CancellationToken): Promise<void> {
        await this.initialize("refreshcache");
        if (cancellationToken.isCancelled) {
            return;
        }
        this.view = new kendo.View(
            `<div class="dms-mapping-header">
                <h1 data-bind="html: getTextBlockpageTitle"></h3>
                <div data-bind="html: getTextBlockpageContent" class="dms-textblock dms-pagecontent"></div>
            </div>
            
            <div class="row col-12">
                <div class="col-sm-12">
                    <div id="refreshCacheGrid" class="dms-grid"></div>
                </div>
            </div>`,
            {
                model: this.viewModel,
                evalTemplate: true,
                wrap: false,
                hide: () => {},
            }
        );

        const provider = await this.serviceProvider.RefreshCache.get();
        if (cancellationToken.isCancelled) {
            return;
        }

        layout.showIn(".dms-content-container", this.view);
        this.serviceProvider.TextBlock.getAll().then((val) => {
            if (cancellationToken.isCancelled) {
                return;
            }
            let item: kendo.ui.GridToolbarItem = {
                template: `<button class='k-button k-primary k-button-icontext dms-control dms-control-button dms-button-clearcache
                }'><span class='k-icon k-i-add'></span>${this.serviceProvider.TextBlock.get("btnSubmit", "refreshcache")}</button>`,
            };

            let grid = new kendo.ui.Grid($("#refreshCacheGrid")[0], {
                dataSource: {
                    data: provider,
                    schema: {
                        model: {
                            id: "ProviderName",
                        },
                    },
                },
                toolbar: [item],
                scrollable: true,
                height: 682,
                sortable: true,
                editable: false,
                selectable: "multiple, row",
                columns: [
                    { selectable: true, width: "50px" },
                    {
                        title: "Name",
                        field: "TextBlockName",
                        template: "#= DMS.Service.TextBlock.get(data.get('TextBlockName'), 'refreshcache') #",
                    },
                ],
            });

            let items = <any>grid.dataSource.data();

            for (const item of items) {
                if (item.InitialChecked) {
                    let tr = $("[data-uid='" + item.uid + "']", grid.tbody);
                    grid.select(tr);
                }
            }
            this.view.element.on("click", ".dms-button-clearcache", () => {
                let keys = grid.selectedKeyNames();
                this.serviceProvider.RefreshCache.refresh(keys).then((tbs) => {
                    for (const tb of tbs) {
                        Navigation.notify(this.serviceProvider.TextBlock.get(tb, "refreshcache"), NotificationTypes.Success);
                    }
                });
            });
        });
    }

    dispose(): void {
        super.dispose();

        if (this.view) {
            this.view.destroy();
        }
    }
}
